import { type } from "@tauri-apps/plugin-os"

export const isServer = () => process.server

export const isClient = () => !isServer()

/** @returns true if we are in a fully production (withpoly.com) environment */
export function isProduction() {
  if (typeof window !== "undefined")
    return window.location.hostname === "poly.app"
  else if (typeof WorkerGlobalScope !== "undefined")
    // eslint-disable-next-line no-restricted-globals
    return self.location.hostname === "poly.app"
  else
    return true // just to be safe
}

/** @returns true if we are running in dev mode (bun run dev) */
export const isDevelopment = () => import.meta.env.DEV

/** @returns true if we are in a tauri webview */
// @ts-expect-error type
export const isDesktop = () => isClient() && !!window.__TAURI__

/** @returns true if we are in a real browser */
export const isBrowser = () => isClient() && !isDesktop()

export const isTesting = () => !!import.meta.env.VITEST

/** @returns true if we are on macOS safari, either on desktop or web */
export async function isSafari() {
  if (isBrowser())
  // @ts-expect-error type
    return window?.safari !== undefined
  return await type() === "macos"
}

export function isMac() {
  if (isClient()) {
    return navigator.platform.toUpperCase().includes("MAC")
      || navigator.platform.toUpperCase().includes("IPAD")
      || navigator.platform.toUpperCase().includes("IPHONE")
  }
  return false
}

export function isWindows() {
  if (isClient()) {
    return navigator.platform.toUpperCase().includes("WIN")
  }
  return false
}

export function isLinux() {
  if (isClient()) {
    return navigator.platform.toUpperCase().includes("LINUX")
  }
  return false
}

/**
 * This function calculates the native machine scrollbar width for the platform in
 * question. On mac, with auto-hiding scrollbars, this should be zero, but if the
 * user has made scrollbars always visible this will be 15px. On windows the width
 * in chrome is 17px. We can use this to decide when to show our custom scrollbar vs
 * showing the user's platform-default scrollbar
 *
 * See: [StackOverflow post](https://stackoverflow.com/questions/55008733/how-can-i-tell-if-the-mac-show-scroll-bars-setting-is-always-on)
 * @returns scrollbar width in pixels
 */
export function getNativeScrollbarWidth() {
  const outer = document.createElement("div")
  outer.style.visibility = "hidden"
  outer.style.width = "100px"
  document.body.appendChild(outer)

  const widthNoScroll = outer.offsetWidth
  outer.style.overflow = "scroll"

  const inner = document.createElement("div")
  inner.style.width = "100%"
  outer.appendChild(inner)

  const widthWithScroll = inner.offsetWidth
  outer.parentNode?.removeChild(outer)

  return widthNoScroll - widthWithScroll
};
